/**
 * Auto Execute Policy
 *
 * When autoExecute is ON and an assistant message arrives with a command plan,
 * automatically starts plan execution.
 */

import { Policy } from '@commandDrivenStateEngine/core/policies';
import { AIAssistantState } from '../state';
import { AIAssistantCommand } from '../commands';

export const createAutoExecutePolicy = (): Policy<AIAssistantState, AIAssistantCommand> => ({
  name: 'auto-execute',

  shouldReact: ( prev, next ) => {
    if ( !next.autoExecute ) return false;
    // React when a new message with a pending plan appears
    if ( prev.messages.length !== next.messages.length ) return true;
    // React when a message transitions from loading to having a plan
    const prevLoading = prev.messages.filter( m => m.isLoading ).length;
    const nextLoading = next.messages.filter( m => m.isLoading ).length;
    if ( prevLoading > 0 && nextLoading < prevLoading ) return true;
    return false;
  },

  onStateChange: ({ next, ctx }) => {
    if ( !next.autoExecute ) return;
    if ( next.executingPlanMessageId ) return; // Already executing

    // Find the latest message with a pending plan
    const pendingPlanMessage = [...next.messages]
      .reverse()
      .find( m => m.commandPlan && m.planStatus === 'pending' );

    if ( pendingPlanMessage ) {
      ctx.dispatch(
        { type: 'aiAssistant/plan/startExecution', payload: { messageId: pendingPlanMessage.id }},
        { source: 'application' }
      );
    }
  }
});
